import { render, staticRenderFns } from "./BSDiscriminatorReset.vue?vue&type=template&id=54aad75c&scoped=true"
import script from "./BSDiscriminatorReset.vue?vue&type=script&lang=js"
export * from "./BSDiscriminatorReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aad75c",
  null
  
)

export default component.exports